import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "@/utils";
import ClientRender from "../../components/ClientRender";
import RxPageLayout from "../../components/ui/display/RxPageLayout";
import StepForwardInfoStrip from "@/components/marketing/step-forward/StepForwardInfoStrip";
import SummitContent from "@/components/marketing/step-forward-2025/SummitContent";
import PartnerStripContent from "@/components/marketing/step-forward-2025/PartnerStripContent";
import QuoteContent2025 from "@/components/marketing/step-forward-2025/QuoteContent";
import TrustedPartnersContent from "@/components/marketing/step-forward-2025/TrustedPartnersContent";
import Hero2025Content from "@/components/marketing/step-forward-2025/Hero2025Content";
import LineUpContent from "@/components/marketing/step-forward-2025/LineUpContent";
import StatsContent from "@/components/marketing/step-forward-2025/StatsContent";
import PillarsContent from "@/components/marketing/step-forward-2025/PillarsContent";
import FullImageCarouselContent from "@/components/marketing/step-forward-2025/FullImageCarouselContent";
import QuoteContent2024 from "@/components/marketing/step-forward-2025/QuoteContent2024";
import ArticlesContent from "@/components/marketing/step-forward-2025/ArticlesContent";
import AsSeenInContent from "@/components/marketing/home/AsSeenInContent";
import Hero2024Content from "@/components/marketing/step-forward-2025/Hero2024Content";
import Summit2024Content from "@/components/marketing/step-forward-2025/Summit2024Content";
import PartnerStrip2024Content from "@/components/marketing/step-forward-2025/PartnerStrip2024Content";
import TicketsContent from "@/components/marketing/step-forward-2025/TicketsContent";
import StagesContent from "@/components/marketing/step-forward-2025/StagesContent";

const carouselOneImages = [
  {
    imageSrc: "/images/step-forward-2025/speakers-on-chairs.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/listening-folded-arms.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/speaker-talking.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/dinner-smiling.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/speakers-laughing.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/looking-at-arm.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/smiling-talking.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/touching-face.png",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/touching-necks.png",
    alt: "",
  },
];

const carouselTwoImages = [
  {
    imageSrc: "/images/step-forward-2025/speakers-katherine.jpg",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/speakers-table.jpg",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/speakers-screen.jpg",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/speakers-audience.jpg",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/speakers-ella-claire.jpg",
    alt: "",
  },
  {
    imageSrc: "/images/step-forward-2025/two-women.jpg",
    alt: "",
  },
];

const StepForward: FunctionComponent = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const headerHeight = 80;
    const targetElement = document.getElementById("tickets-section");

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - headerHeight - 100,
        behavior: "smooth",
      });
    }
  };

  return (
    <ClientRender>
      <RxPageLayout>
        <StepForwardInfoStrip
          colour={colours.stepForwardNavy}
          textColour={colours.shell}
        >
          <b>Step Forward with AllBright</b> for International Women’s Day
          2025...
        </StepForwardInfoStrip>
        <Hero2025Content />
        <StepForwardInfoStrip colour={colours.stepForwardLilac}>
          <b>Let’s #StepForward for the issues that matter most, together.</b>
        </StepForwardInfoStrip>
        <PartnerStripContent />
        <SummitContent handleClick={(e) => handleClick(e)} />
        <TicketsContent />
        <StatsContent />
        <FullImageCarouselContent images={carouselOneImages} />
        <PillarsContent handleClick={(e) => handleClick(e)} />
        <StagesContent handleClick={(e) => handleClick(e)} />
        <LineUpContent />
        <TrustedPartnersContent />
        <QuoteContent2025 />
        <ArticlesContent />
        <Hero2024Content />
        <PartnerStrip2024Content />
        <Summit2024Content handleClick={(e) => handleClick(e)} />
        <FullImageCarouselContent images={carouselTwoImages} />
        <QuoteContent2024 />
        <AsSeenInContent />
      </RxPageLayout>
    </ClientRender>
  );
};

const S = () => {};

S.BoldWrap = styled.span`
  font-weight: 700;
`;

S.ModalCopy = styled.div`
  padding: 0 3rem 2rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default StepForward;
